import React from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { useSelector } from 'react-redux';

import { User } from 'models/User';

import { WS_COMPANY_CHANNEL, WS_USER_CHANNEL } from './config/Constants';
import { useSocketRoom } from './context/WebSocketContext';
import AppRoutes from './routes/routes';

import './App.scss';

dayjs.locale('es');

function App() {
  const authUser = useSelector((state: any) => state.auth) as User;

  useSocketRoom(
    authUser?.id
      ? WS_USER_CHANNEL.replace('[USER_ID]', `${authUser.id}`)
      : undefined
  );

  useSocketRoom(
    authUser?.id
      ? WS_COMPANY_CHANNEL.replace('[COMPANY_ID]', `${authUser.company.id}`)
      : undefined
  );

  return <AppRoutes />;
}

export default App;
